import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import PaidInvoicePage from './PaidInvoicePage';
import { getUserPaidInvoiceData, printReceipt } from 'src/actions/paidInvoiceAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { PaidInvoiceData } from 'src/reducers/paidinvoice';

export const mapStateToProps = (state: AppState) => {
  return {
    paidInvoiceData: state.paidInvoice.getPaidInvoiceData,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      // dispatch(getUserPaidInvoiceData());
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
    },
    dateFilter: (filterStartdate: Date, filterEnddate: Date) => {
      dispatch(getUserPaidInvoiceData(filterStartdate, filterEnddate));
    },
    dateReset: (filterStartdate: Date, filterEnddate: Date) => {
      dispatch(getUserPaidInvoiceData(filterStartdate, filterEnddate));
    },
    printReceipt: (txn: PaidInvoiceData) => {
      dispatch(printReceipt(txn));
    }
  };
};

const PaidInvoicePageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaidInvoicePage);

export default PaidInvoicePageContainer;



// WEBPACK FOOTER //
// ./src/components/PaidInvoice/PaidInvoicePageContainer.tsx